import { Alert, Stack, Typography } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import PermissionsFields from "../PermissionsFields";
import type { NewContactState } from "./newContactState";
import {
  getContactsCountLabel,
  getSelectedFundsCountLabel,
  setAllCategoriesSelectionAction,
  toggleCategorySelectionAction,
  updateRoleAction,
} from "./newContactState";

interface Props {
  state: NewContactState;
  setState: Dispatch<SetStateAction<NewContactState>>;
}

const PermissionsForm = ({ state, setState }: Props) => (
  <Stack spacing={2.5}>
    <Alert severity="info">
      <Typography>
        You are adding <strong>{getContactsCountLabel(state)}</strong> to{" "}
        <strong>{getSelectedFundsCountLabel(state)}</strong>
      </Typography>
    </Alert>
    <PermissionsFields
      role={state.role}
      roleOptions={["Member", "Admin"]}
      selectedCategoryExternalIds={state.selectedCategoryExternalIds}
      onRoleChange={(role) => setState(updateRoleAction(role))}
      onToggleCategory={(categoryExternalId) => setState(toggleCategorySelectionAction(categoryExternalId))}
      onSetAllCategories={(allCategoryExternalIds, selected) =>
        setState(setAllCategoriesSelectionAction(allCategoryExternalIds, selected))
      }
    />
  </Stack>
);

export default PermissionsForm;
